import { WatermarkRemovalStudio } from "components/_dashboard/watermarks/WatermarkRemovalStudio";

type ListingWatermarksTabProps = {
  listingId: string;
};

export function ListingWatermarksTab({ listingId }: ListingWatermarksTabProps): JSX.Element {
  return <WatermarkRemovalStudio listingId={listingId} />;
}

export default ListingWatermarksTab;
